import type { ColumnDef } from '@tanstack/react-table';

import { type GetProductArrangementsQuery } from 'data/__generated__';
import { textColumn, numberColumn } from 'components/DataTable';

type ProductArrangementFromQuery = GetProductArrangementsQuery['productArrangementsQuery'][number];

export type ProductArrangementRow = ProductArrangementFromQuery & {
    numberOfProducts: number;
};

export const productArrangementsColumns: ColumnDef<ProductArrangementRow, unknown>[] = [
    textColumn<ProductArrangementRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    numberColumn<ProductArrangementRow, Record<string, unknown>>({
        accessorKey: 'numberOfProducts',
        header: 'Nombre de produits',
        defaultVisible: true,
    }),
];
